module.exports = __webpack_public_path__ + "static/media/full-spa-body-massage-and-kerokan.536e736b.webp";